import { render } from "./MainHeader.vue?vue&type=template&id=496164fd"
const script = {}

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__